import { Component, Input, OnInit } from '@angular/core';
import { Notams } from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';
import { CreateScheduleService } from '@app/shared/services/create-schedule.service';

@Component({
    selector: 'app-notams',
    templateUrl: './notams.component.html',
    styleUrls: ['./notams.component.scss'],
    standalone: false
})
export class NotamsComponent implements OnInit {
  public notams = new Notams();
  public notamsListing: any;
  public notamsSegment: number = 0;
  public stationSwitch = 0;
  public airportdata = 0;
  @Input() public type?: string;
  @Input() public iCAOCode?: string;
  @Input() public iCAOCodeSel?: string;

  public wxWeather: any;
  public wxWeatherSel: any;
  constructor(public flightPlanService: FlightPlanService, private scheduleService: CreateScheduleService) { }

  public ngOnInit() { }
  public openAccordian() {
    this.flightPlanService.accordionSwitch('notam');
  }
  public ngAfterViewInit() {
    if (this.type == 'airportInfo') {
      const fromCode = (this.iCAOCode || '').trim();
      const toCode = (this.iCAOCodeSel || '').trim();
      if (fromCode) {
        this.scheduleService.getSingleStationNotams(fromCode).then((wxNotams: any) => {
          this.wxWeather = wxNotams;
        });
      }
      if (toCode) {
        this.scheduleService.getSingleStationNotams(toCode).then((wxNotams: any) => {
          this.wxWeatherSel = wxNotams;
        });
      }
    } else {
      this.flightPlanService.getNotams().then((data) => {
        this.notamsListing = data;
      });
    }
  }
}
